/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DailyReportingPeriodData } from './DailyReportingPeriodData';
import {
    DailyReportingPeriodDataFromJSON,
    DailyReportingPeriodDataFromJSONTyped,
    DailyReportingPeriodDataToJSON,
    DailyReportingPeriodDataToJSONTyped,
} from './DailyReportingPeriodData';
import type { TurnoverByDomain } from './TurnoverByDomain';
import {
    TurnoverByDomainFromJSON,
    TurnoverByDomainFromJSONTyped,
    TurnoverByDomainToJSON,
    TurnoverByDomainToJSONTyped,
} from './TurnoverByDomain';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface DailyReportingCompositionData
 */
export interface DailyReportingCompositionData {
    /**
     * 
     * @type {DailyReportingPeriodData}
     * @memberof DailyReportingCompositionData
     */
    current?: DailyReportingPeriodData;
    /**
     * 
     * @type {DailyReportingPeriodData}
     * @memberof DailyReportingCompositionData
     */
    previousDay?: DailyReportingPeriodData;
    /**
     * 
     * @type {DailyReportingPeriodData}
     * @memberof DailyReportingCompositionData
     */
    previousWeek?: DailyReportingPeriodData;
    /**
     * 
     * @type {TurnoverByDomain}
     * @memberof DailyReportingCompositionData
     */
    domains?: TurnoverByDomain;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof DailyReportingCompositionData
     */
    currentSnapshot?: PrecalculationSnapshotReadMetadata;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof DailyReportingCompositionData
     */
    previousDaySnapshot?: PrecalculationSnapshotReadMetadata;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof DailyReportingCompositionData
     */
    previousWeekSnapshot?: PrecalculationSnapshotReadMetadata;
}

/**
 * Check if a given object implements the DailyReportingCompositionData interface.
 */
export function instanceOfDailyReportingCompositionData(value: object): value is DailyReportingCompositionData {
    return true;
}

export function DailyReportingCompositionDataFromJSON(json: any): DailyReportingCompositionData {
    return DailyReportingCompositionDataFromJSONTyped(json, false);
}

export function DailyReportingCompositionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyReportingCompositionData {
    if (json == null) {
        return json;
    }
    return {
        
        'current': json['current'] == null ? undefined : DailyReportingPeriodDataFromJSON(json['current']),
        'previousDay': json['previousDay'] == null ? undefined : DailyReportingPeriodDataFromJSON(json['previousDay']),
        'previousWeek': json['previousWeek'] == null ? undefined : DailyReportingPeriodDataFromJSON(json['previousWeek']),
        'domains': json['domains'] == null ? undefined : TurnoverByDomainFromJSON(json['domains']),
        'currentSnapshot': json['currentSnapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['currentSnapshot']),
        'previousDaySnapshot': json['previousDaySnapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['previousDaySnapshot']),
        'previousWeekSnapshot': json['previousWeekSnapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['previousWeekSnapshot']),
    };
}

export function DailyReportingCompositionDataToJSON(json: any): DailyReportingCompositionData {
    return DailyReportingCompositionDataToJSONTyped(json, false);
}

export function DailyReportingCompositionDataToJSONTyped(value?: DailyReportingCompositionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current': DailyReportingPeriodDataToJSON(value['current']),
        'previousDay': DailyReportingPeriodDataToJSON(value['previousDay']),
        'previousWeek': DailyReportingPeriodDataToJSON(value['previousWeek']),
        'domains': TurnoverByDomainToJSON(value['domains']),
        'currentSnapshot': PrecalculationSnapshotReadMetadataToJSON(value['currentSnapshot']),
        'previousDaySnapshot': PrecalculationSnapshotReadMetadataToJSON(value['previousDaySnapshot']),
        'previousWeekSnapshot': PrecalculationSnapshotReadMetadataToJSON(value['previousWeekSnapshot']),
    };
}

